<template>
  <v-layout column class="pa-2">

    <v-layout v-if="user.role == 'employee'">
      <v-flex v-if="notes.length == 0 && user.id == shift.userId" xs12>
        <v-textarea
          class="employee-notes"
          :disabled="beyond72hours"
          label="Internal Notes"
          v-model="newNote"
          auto-grow
          box
        >
        </v-textarea>
        <v-layout align-center row>
          <v-btn :disabled="beyond72hours" @click="createNote">Add Note</v-btn>
          <v-flex v-if="beyond72hours" class="subtle subheading">
            This shift ended more than 72 hours ago
          </v-flex>
        </v-layout>
      </v-flex>

      <v-flex v-for="note in notes" xs12>
        <div v-if="beyond72hours">
          <v-textarea
            class="employee-notes"
            :readonly="beyond72hours"
            label="Internal Notes"
            v-model="note.note"
            auto-grow
            box
          >
          </v-textarea>
        </div>
        <div v-else>
          <ApiField
            class="employee-notes"
            v-if="note.userId == user.id"
            fieldType="textarea"
            storeAction="shifts/updateNote"
            storeUpdate="shifts/refreshNotes"
            paramName="shift_note"
            :object="note"
            fieldName="note"
            :storeFieldValue="note.note"
            label="Internal Notes"
          >
          </ApiField>
        </div>
        <v-layout align-center row>
          <v-btn v-if="note.userId == user.id" :disabled="beyond72hours" @click="">Update Note</v-btn>
          <v-flex v-if="beyond72hours" class="subtle subheading">
            This shift ended more than 72 hours ago
          </v-flex>
        </v-layout>

      </v-flex>
    </v-layout>

    <v-layout v-if="user.managerOrHigher">
      <v-flex v-for="note in notes" xs12>
        <v-textarea
          :value="note.note"
          :label="`${ note.authorName }'s Notes (${ note.authorRole })`"
          auto-grow
          box
          disabled
          >
        </v-textarea>
      </v-flex>
    </v-layout>

  </v-layout>

</template>

<script>
import { mapGetters, mapState } from 'vuex'
import ApiField from '@/components/base/api-field.vue'

export default {
  components: {
    ApiField,
  },
  computed: {
    ...mapState('userAuth', [
      'user'
    ]),
    ...mapState('shifts', [
      'notes',
    ]),
    beyond72hours: function() {
      const timeAgo = this.$moment().subtract(72, 'hours');
      const shiftEnded = this.$moment(this.shift.endDatetime);

      return this.$moment(shiftEnded).isBefore(timeAgo);
    },
  },
  props: {
    shift: Object,
  },
  created () {
    this.setUp();
  },
  data () {
    return {
      newNote: '',
    }
  },
  methods: {
    setUp () {
      this.$store.dispatch('shifts/getNotes', { shiftId: this.shift.id })
    },
    createNote () {
      this.$store.dispatch('shifts/createNote', {
        shiftId: this.shift.id,
        userId: this.user.id,
        note: this.newNote
      })
      .then(res => {
        this.newNote = ''
      })
    },
  },
}
</script>
